import { RouteCollection } from "@vm/vue-core";

import ComparisonSettingsEditorPage from "./components/pages/comparison-settings-editor-page.vue";

export default {
  basePath: "/editor",
  routes: [
    {
      path: "/",
      name: "editor",
      component: ComparisonSettingsEditorPage,
    },
  ],
} satisfies RouteCollection;
